module.exports = __webpack_public_path__ + "static/img/no6.3212fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no6.png
// module id = ktri
// module chunks = 31